
import { FirearmPoolTypeInfoBase } from './firearm-pool.typeinfo.base';


export class FirearmPoolTypeInfo extends FirearmPoolTypeInfoBase {
}

export const FIREARM_POOL_TYPE: FirearmPoolTypeInfo = new FirearmPoolTypeInfo();



